import { Backdrop, CircularProgress } from "@mui/material";
import type { FC } from "react";

type LoadingPageProps = {
  showing: boolean;
};

export const LoadingPage: FC<LoadingPageProps> = ({ showing }) => (
  <Backdrop
    sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
    open={showing}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);
